module.exports = __webpack_public_path__ + "static/media/marker-green.f91200a3.svg";